import { FormSection } from '../../../components';
import { FieldError } from '@oforce/global-components';
import Select from 'react-select';
import { Alert } from 'reactstrap';
import { usePolicies } from '../../policies/hooks';

export default function PolicySelection({ formik }) {
  const { policies, loading, error } = usePolicies({
    initialFilters: { archived: null }
  });

  const policyOptions = policies?.map(policy => ({
    value: policy?.id,
    label: `${policy?.name} - ${policy?.product?.insuranceType?.type}`
  }));

  const selectedPolicy = policyOptions?.find(option => option.value === formik?.values?.policyId);

  return (
    <FormSection title="Select Policy">
      <FieldError name="policyId" />
      <div className="mb-3">
        <Select
          name="policyId"
          options={policyOptions}
          value={selectedPolicy}
          onChange={option => formik?.setFieldValue('policyId', option?.value)}
          isLoading={loading}
          isDisabled={loading || error}
          placeholder="Select a policy..."
          isClearable
        />
      </div>
      {error && (
        <Alert color="danger" className="mb-2">
          Error loading policies. Please try again.
        </Alert>
      )}
    </FormSection>
  );
}
